import React, { useEffect, useRef } from 'react';
import PropTypes from 'prop-types';

import styles from './uploadInteraction.scss';

const UploadButton = ({
    disabled,
    handleFileSelection,
    id,
    isFocused,
    supportedFileExtensions,
    text,
}) => {
    const inputFileRef = useRef(null);
    const acceptProp = supportedFileExtensions === '*' ? undefined : supportedFileExtensions;
    const className = disabled ? styles.uploadButtonLabelDisabled : styles.uploadButtonLabel;

    useEffect(() => {
        if (isFocused) {
            inputFileRef.current.focus();
        }
    }, []);

    const onChange = (event) => {
        const file = event.target.files?.[0];
        if (file) {
            handleFileSelection(file);
        }
    };

    return (
        <div>
            <input
                className={styles.uploadInput}
                id={id}
                accept={acceptProp}
                ref={inputFileRef}
                disabled={disabled}
                onChange={onChange}
                type="file"
                aria-labelledby={id}
            />

            <label htmlFor={id} className={`${styles.button} ${className}`}>
                <i className="fa fa-folder-open-o" aria-hidden="true" />
                <span>{text}</span>
            </label>
        </div>
    );
};

UploadButton.propTypes = {
    disabled: PropTypes.bool,
    handleFileSelection: PropTypes.func.isRequired,
    id: PropTypes.string.isRequired,
    isFocused: PropTypes.bool,
    supportedFileExtensions: PropTypes.string.isRequired,
    text: PropTypes.string.isRequired,
};

UploadButton.defaultProps = {
    disabled: false,
    isFocused: false,
};

export default UploadButton;
